import {EquipmentData, EquipmentPlain, Iso8601, SapDataDto, User} from '@hconnect/common/types'

import {TaskAssignee, TaskSource, TaskStatus} from './task.types'

export const DALOG_ACTION_STATUSES = [
  TaskStatus.Pending,
  TaskStatus.Ongoing,
  TaskStatus.Done
] as const
export type DalogActionStatus = (typeof DALOG_ACTION_STATUSES)[number]

export enum DalogActionPriority {
  Immediately = 'immediately',
  OneDay = 'oneDay',
  OneWeek = 'oneWeek',
  OneMonth = 'oneMonth'
}

export type DalogProperties = {
  assignee?: string
  functionalLocation?: string
  processStage?: string
  sapPmWorkOrder?: string
  comment?: string
}

export type DalogActionFormValues = {
  plantUpmId: string
  source: TaskSource
  status: DalogActionStatus
  title: string
  description: string
  dueDate?: Iso8601 | null
  priority?: DalogActionPriority
  functionalLocation?: string | null
  equipment?: EquipmentPlain
  mainEquipment?: EquipmentData
  processStage?: string | null
  assignees: User[]
}

export type DalogActionDto = {
  id: string
  actionId: string
  plantUpmId: string
  title: string
  description: string
  status: DalogActionStatus
  createdOn: Iso8601
  createdBy: string
  lastModified?: Iso8601
  dueDate: Iso8601 | null
  priority?: DalogActionPriority
  dalogProperties: DalogProperties
  assignees: TaskAssignee[]
  equipment: EquipmentData
  mainEquipment?: EquipmentData
  processStage?: string
  sapInfo?: SapDataDto
}

export type EditDalogActionDto = {
  title: string
  description: string
  status: DalogActionStatus
  dueDate: Iso8601 | null
  priority?: DalogActionPriority
  functionalLocation?: string | null
  equipmentId?: string
  equipmentIdType?: string
  equipmentText?: string
  mainEquipmentId?: string
  mainEquipmentIdType?: string
  mainEquipmentText?: string
  processStage?: string | null
  assignees: string[]
}

export type EditDalogAction = EditDalogActionDto & {
  id: string
  plantUpmId: string
}

export type CreateDalogMaintenanceNotificationActionDto = {
  workCenterId?: string
  plannerGroupId?: string
}
